<template>
    <div class="app">
        <div class="header_box">
            <h-top></h-top>
            <div class="header_logo">
                <div class="header_logos dis-between">
                    <img
                        @click="jumpClick"
                        src="../assets/image/iocn/917logos.png"
                    >
                    <div class="header_input">
                        <!-- <span @click="choose_city">{{cityname}}</span><img src="../assets/image/iocn/choose_city.png" /> -->
                        <div class="input-box">
                            <div class="input-box-inputbox dis">
                                <div><img
                                        class="hea-img"
                                        src="../assets/image/iocn/sousuo.png"
                                    /></div>
                                <input
                                    class="hea-input"
                                    style="outline:none;"
                                    placeholder="搜索商品"
                                    v-model="searchValue"
                                    @keydown.enter.stop="user_search"
                                />
                            </div>
                            <div
                                class="header_inputs"
                                @click="user_search"
                            >
                                搜索
                                <!-- <div class="header_inputsimgs"></div> -->
                            </div>
                        </div>
                        <div class="search-hot">热门搜索:&nbsp;&nbsp;西瓜&nbsp;&nbsp;&nbsp;&nbsp;白菜&nbsp;&nbsp;&nbsp;&nbsp;五花肉&nbsp;&nbsp;&nbsp;&nbsp;茄子 </div>
                    </div>
                    <div
                        class="shopcart-btn"
                        @click="goShopcart"
                        style="cursor: pointer;"
                    >
                        <img
                            style="margin-left:15px"
                            src="../assets/image/iocn/carticon.png"
                            alt=""
                        >
                        <p>购物车</p>
                        <!-- <span>{{cartLength}}</span> -->
                    </div>
                </div>
            </div>
            <div class="header_title">
                <div class="header_titles">
                    <div class="header_tilis">
                        <div
                            class="header_lis"
                            @mouseover="allShopitem"
                            @mouseleave="closetype"
                        >
                            <div class="header_lisimgs"></div>
                            <p>
                                <p class="header_lisimgsA"></p>
                                全部商品分类
                            </p>
                        </div>
                        <div class="header_titlet">
                            <div
                                class="header_titletA"
                                :class="{navActive:navIndexs==index}"
                                v-for="(item,index) in navList"
                                :key="index"
                                @click="changeNav(index)"
                            >
                                {{item}}
                                <div
                                    class="hea-xian"
                                    v-show="navIndexs === index"
                                ></div>
                            </div>
                            <!-- <div class="header_titletA" @click="join">
								申请加盟
							</div>
							<div class="header_titletA" @click="dyindex">
								关于我们
							</div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-show="showShop==true"
                class="showAllshop-box"
                id="allshop"
                @mouseleave="closealltype"
            >
                <div class="showShop-left">
                    <div
                        class="showShop-left-item"
                        :class="{typeactive:activeIndex==index}"
                        @mouseover="showType(index,item.children)"
                        v-for="(item,index) in bigTypedata"
                        :key="index"
                    >
                        <div
                            v-if="item.type == 2"
                            class="zhekou"
                        >
                            <span>{{item.name}}</span>
                        </div>
                        <div
                            v-else-if="item.type == 3"
                            class="jifen"
                        >
                            <span>{{item.name}}</span>
                        </div>
                        <div v-else>{{item.name}}</div>
                    </div>
                </div>
                <div
                    class="showShop-right"
                    v-show="typeflag"
                >
                    <div class="product-list-title">商品列表</div>
                    <div class="product-line2"></div>
                    <div
                        v-for="(type,index) in sencondType"
                        :key="index"
                        :class="{type2:type.type ==2 || type.type ==3}"
                    >
                        <div class="product-name-box">
                            <div
                                class="product-name"
                                v-if="type.type == 1"
                            >{{type.name}}&nbsp;:</div>
                            <div
                                v-if="type.type == 1"
                                class="product-subtype-name"
                            >
                                <div class="dis-between right-wid">
                                    <div class="dis right-wid-son">
                                        <div v-for="(item,i) in sencondType[index].children" :key="i">
                                            <p v-if="!type.is_show && i < 24" :class="{listactive:childId==item.id}">
                                                <span v-if="item.type==1" @click="choosechildType(i,type.id,item.id)">{{item.name}}</span>
                                                <!-- <router-link v-else :to="{path:'/discount_list', query:{TwoCategoryId:item.parentId}}" >{{item.name}}</router-link> -->
                                            </p>
                                            <p v-else-if="type.is_show" :class="{listactive:childId==item.id}">
                                                <span v-if="item.type==1" @click="choosechildType(i,type.id,item.id)">{{item.name}}</span>
                                                <!-- <router-link v-else :to="{path:'/discount_list', query:{TwoCategoryId:item.parentId}}" >{{item.name}}</router-link> -->
                                            </p>
                                        </div>
                                    </div>
                                    <!------------------------------------------------->
                                    <div v-if="sencondType[index].children.length > 24" class="right-title-p">
                                        <div v-if="!type.is_show" class="dis"><div @click="lookMoreClick(index)">查看更多</div><img class="right-jiantou" src="../assets/image/fljiantou2.png"/></div>
                                        <div v-else class="dis"><div @click="putClick(index)">收起分类</div><img class="right-jiantou" src="../assets/image/fljiantou1.png"/></div>
                                    </div>
                                </div>
                            </div>
                            <!----------------------------->
                            <div v-else-if="type.type == 3">
                                <p class="product-discont-name product-discont-name2 zk-new-p">
                                    <router-link
                                        style="text-decoration:none;"
                                        :to="{path:'/discount_list_two',
                                        query:{TwoCategoryId:type.parentId, categoryId:type.id}}"
                                    >{{type.name}}</router-link>
                                </p>
                            </div>
                            <!----------------------------->
                            <div v-else-if="type.type == 2">
                                <p class="product-discont-name product-discont-name3 zk-new-p">
                                    <router-link
                                        style="text-decoration:none;"
                                        :to="{path:'/discount_list',
                                        query:{TwoCategoryId:type.parentId, categoryId:type.id}}"
                                    >{{type.name}}</router-link>
                                </p>
                            </div>
                            <!----------------------------->
                            <div
                                class="product-name"
                                v-if="type.type == 4"
                            >{{type.name}}&nbsp;:</div>
                            <div
                                v-if="type.type == 4"
                                class="product-subtype-name"
                            >
                                <div class="dis-between right-wid">
                                    <div class="dis right-wid-son">
                                        <div v-for="(item,i) in sencondType[index].children" :key="i">
                                            <p v-if="!type.is_show && i < 16" :class="{listactive:childId==item.id}">
                                                <span v-if="item.type==4" @click="eatSnackClick(type.parentId,type.id,item.id)">{{item.name}}</span>
                                            </p>
                                            <p v-else-if="type.is_show" :class="{listactive:childId==item.id}">
                                                <span v-if="item.type==4" @click="eatSnackClick(type.parentId,type.id,item.id)">{{item.name}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <!------------------------------------------------->
                                    <div v-if="sencondType[index].children.length > 16" class="right-title-p">
                                        <div v-if="!type.is_show" class="dis"><div @click="lookMoreClick(index)">查看更多</div><img class="right-jiantou" src="../assets/image/fljiantou2.png"/></div>
                                        <div v-else class="dis"><div @click="putClick(index)">收起分类</div><img class="right-jiantou" src="../assets/image/fljiantou1.png"/></div>
                                    </div>
                                </div>
                            </div>
                            <!----------------------------->
                            <div
                                class="product-name"
                                v-if="type.type == 5"
                            >{{type.name}}&nbsp;:</div>
                            <div
                                v-if="type.type == 5"
                                class="product-subtype-name"
                            >
                                <div class="dis-between right-wid">
                                    <div class="dis right-wid-son">
                                        <div v-for="(item,i) in sencondType[index].children" :key="i">
                                            <p v-if="!type.is_show && i < 16" :class="{listactive:childId==item.id}">
                                                <span v-if="item.type==5" @click="eatSnackLocalityClick(type.parentId,type.id,item.id)">{{item.name}}</span>
                                            </p>
                                            <p v-else-if="type.is_show" :class="{listactive:childId==item.id}">
                                                <span v-if="item.type==5" @click="eatSnackLocalityClick(type.parentId,type.id,item.id)">{{item.name}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <!------------------------------------------------->
                                    <div v-if="sencondType[index].children.length > 16" class="right-title-p">
                                        <div v-if="!type.is_show" class="dis"><div @click="lookMoreClick(index)">查看更多</div><img class="right-jiantou" src="../assets/image/fljiantou2.png"/></div>
                                        <div v-else class="dis"><div @click="putClick(index)">收起分类</div><img class="right-jiantou" src="../assets/image/fljiantou1.png"/></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="type.type == 1 || type.type == 4 || type.type == 5"
                            class="product-line"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HTop from "./header/h-top.vue"
    export default
    {
        props: [ "navIndex" ],
        name: 'App',
        components: { HTop },
        data()
        {
            return {
                searchValue: '', //搜索框内容
                childId: 0,
                userName: '',
                cityname: '金华市',
                navList: [
                    "首页","名小吃","本地小吃", "折扣专区", "积分兑换","申请加盟", "关于我们" 
                ],
                navIndexs: 0,
                showShop: false,
                typeflag: false,
                activeIndex: -1,
                bigTypedata: [],
                childType: [ '瓜类', '根茎类' ],
                sencondType: [],
                cartLength: 0,
                token: '',
                categoryId: null,
                twoCategoryId: null,
            }
        },
        mounted()
        {
            let cityname = localStorage.getItem( 'cityname' );
            let token = localStorage.getItem( 'token' );
            this.token = token;
            if ( cityname == undefined )
            {
                this.cityname = '金华市'; // !!! 在它之前已经处理了，这里无意义
            }
            else
            {
                this.cityname = cityname; // !!! 在它之前已经处理了，这里无意义
            }
            this.navIndexs = this.navIndex;
            let name = localStorage.getItem( 'username' );
            this.userName = name;
            this.getcartLength();
            let that = this;
            // 用户按下回车键进行搜索
            // document.onkeydown = () =>
            // {
            //     let key = window.event.keyCode
            //     if ( key === 13 )
            //     {
            //         that.user_search();
            //     }
            // }
        },
        methods:
        {
            jumpClick()
            {
                this.$router.push( { path: "/" } )
            },
            user_search()
            { //用户搜索商品
                if ( this.searchValue == '' )
                {
                    this.$message(
                    {
                        message: '搜索内容不能为空!',
                        type: 'warning'
                    } )
                }
                else
                {
                    let cityname = JSON.parse( localStorage.getItem( 'cityname' ) )
                    let params = {
                        PageNo: 1,
                        PageSize: 20,
                        Params:
                        {
                            Name: this.searchValue,
                            TwoCategoryId: null, //必填
                            CategoryId: null, //第三级分类(不选传unll)
                            PriceDesc: null, //价格是否倒序(选填 不排序就传unll)
                            TimeDesc: null, //最新是否倒序(选填 不要就传unll)
                            regionId: cityname.threeId > 0?cityname.threeId: null,
                            cityId: cityname.twoId,
                        }
                    }
                    this.$api.product.goodsList( params ).then( res =>
                    {
                        if ( res.data.code == 0 && res.data.result.data.length != 0 )
                        {
                            this.$router.push(
                            {
                                path: "/productlist",
                                query:
                                {
                                    type: 1,
                                    name: this.searchValue
                                }
                            } )
                            window.location.reload();
                        }
                        else if ( res.data.result.data.length == 0 )
                        {
                            this.$message(
                            {
                                message: '没有该商品,换一个试试!',
                                type: 'warning'
                            } )
                        }
                        else
                        {
                            this.$message(
                            {
                                message: res.data.message,
                                type: 'warning'
                            } )
                        }
                    } )
                }
            },
            getcartLength()
            {
                //获取购物车条数
                // let params = {
                //     PageNo: 1,
                //     PageSize: 10
                // }
                // this.$api.product.shopcartList( params ).then( res =>
                // {
                //     if ( res.data.code == 0 )
                //     {
                //         this.cartLength = res.data.result.totalCount;
                //     }
                //     else
                //     {
                //         // this.$message({
                //         // 	message:res.data.message,
                //         // 	type:'warning'
                //         // })
                //     }
                // } )
            },
            openchild()
            {
                this.showShop = true;
                this.typeflag = true;
            },
            closealltype()
            { //鼠标移出关闭所有子元素
                this.activeIndex = -1;
                this.showShop = false;
                this.typeflag = false;
            },
            choosechildType( index, TwoCategoryId, categoryId )
            {
                this.childId = TwoCategoryId;
                let path = this.$route.path;
                this.$router.push(
                {
                    path: '/productlist',
                    query:
                    {
                        twoCategoryId: TwoCategoryId,
                        categoryId: categoryId
                    }
                } )
            },
            eatSnackClick(OneCategoryId, TwoCategoryId, categoryId) {
                // if ( !localStorage.getItem('token') )
                // {
                //     this.$confirm( '此操作需要登录, 是否前往登录?', '提示',
                //     {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     } ).then( () =>
                //     {
                //         this.$router.push({path: '/login'})
                //     } ).catch( () =>
                //     {
                //         // ...
                //     } )
                //     return
                // }
                if (!JSON.parse( localStorage.getItem( 'AddressActObj' )) ) {
                    this.$confirm( '请选择收货地址？', '提示',
                    {
                        confirmButtonText: '前往选择',
	                    showCancelButton: false,
						showClose: false,
						closeOnClickModal: false,
                        // cancelButtonText: '取消',
                        type: 'warning'
                    }).then( () =>
                    {
                        localStorage.setItem( 'isSetOneAddress', 1 )
                        this.$router.push( { path: '/marketlist?num=2' } )
                    }).catch( () =>
                    {
                        // ...
                    })
                    return
                }

                this.$router.push(
                {
                    path: '/famoussnacks_list',
                    query:
                    {   OneCategoryId: OneCategoryId,
                        TwoCategoryId: TwoCategoryId,
                        categoryId: categoryId
                    }
                } )
            },
            eatSnackLocalityClick(OneCategoryId, TwoCategoryId, categoryId) {
                // if ( !localStorage.getItem('token') )
                // {
                //     this.$confirm( '此操作需要登录, 是否前往登录?', '提示',
                //     {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     } ).then( () =>
                //     {
                //         this.$router.push({path: '/login'})
                //     } ).catch( () =>
                //     {
                //         // ...
                //     } )
                //     return
                // }
                if (!JSON.parse( localStorage.getItem( 'AddressActObj' )) ) {
                    this.$confirm( '请选择收货地址？', '提示',
                    {
                        confirmButtonText: '前往选择',
	                    showCancelButton: false,
						showClose: false,
						closeOnClickModal: false,
                        // cancelButtonText: '取消',
                        type: 'warning'
                    }).then( () =>
                    {
                        localStorage.setItem( 'isSetOneAddress', 1 )
                        this.$router.push( { path: '/marketlist?num=2' } )
                    }).catch( () =>
                    {
                        // ...
                    })
                    return
                }

                this.$router.push(
                {
                    path: '/famoussnacks_locality_list',
                    query:
                    {   OneCategoryId: OneCategoryId,
                        TwoCategoryId: TwoCategoryId,
                        categoryId: categoryId
                    }
                } )
            },
            async getproductType()
            { //获取产品分类
                let res = await this.$api.product.ProductCategoryTree();

                if ( res.data.code === 0 )
                {
                    this.bigTypedata = res.data.result;
                }
            },
            loginOut()
            { //退出登录
                localStorage.setItem( 'token', '' )
                localStorage.setItem( 'username', '' )
                this.userName = ''
                this.$router.push(
                {
                    path: "/"
                } )
            },
            choose_city()
            { //选择城市
                this.$router.push(
                {
                    path: '/choosecity'
                } )
            },
            myNews()
            { //我的消息
                this.$router.push(
                {
                    path: ''
                } )
            },
            myorder()
            { //我的订单
                localStorage.setItem( 'personal', 0 )
                this.$router.push(
                {
                    path: "/order",
                    query:
                    {
                        index: 0
                    }
                } )
            },
            go_mysave()
            { //我的关注
                localStorage.setItem( 'personal', 1 )
                this.$router.push(
                {
                    path: '/order',
                    query:
                    {
                        index: 1
                    }
                } )
            },
            lookMoreClick(idx) {
                this.typeflag = false
                for(let i = 0; i < this.sencondType.length; i++) {
                    this.sencondType[i].is_show = false
                }
                this.sencondType[idx].is_show = true
                this.typeflag = true
            },
            putClick(idx) {
                this.typeflag = false
                this.sencondType[idx].is_show = false
                this.typeflag = true
            },
            showType( index, data )
            {
                for (let i = 0; i < data.length; i++) {
                    data[i]['is_show'] = false
                }
                this.typeflag = true;
                this.activeIndex = index;
                this.sencondType = data;
            },
            closetype()
            { //鼠标移出后关闭
                // this.showShop = false;
            },
            allShopitem( event )
            { //点击全部商品列表
                this.getproductType();
                this.activeIndex = -1;
                this.showShop = true;
                this.typeflag = false;
            },
            changeNav( index )
            {
                this.navIndexs = index;
                if ( index == 0 )
                {
                    this.$router.push(
                    {
                        path: '/'
                    } )
                }
                else if ( index == 1 )
                {
                    this.$router.push(
                    {
                        path: '/famoussnacks'
                    } )
                    
                }
                else if ( index == 2 )
                {
                    this.$router.push(
                    {
                        path: '/famoussnacks_locality'
                    } )
                    
                }
                else if ( index == 3 )
                {
                    this.$router.push(
                    {
                        path: '/discount'
                    } )
                    
                }
                else if ( index == 4 )
                {
                    this.$router.push(
                    {
                        path: '/indextwo'
                    } )
                }
                else if ( index == 5 )
                {
                    this.$router.push(
                    {
                        path: "/join"
                    } )
                }
                else if ( index == 6 )
                {
                     this.$router.push(
                    {
                        path: '/aboutour'
                    } )
                   
                }
            },
            goShopcart()
            { //跳转购物车
                this.$router.push(
                {
                    path: "/shopCart"
                } )
            },
            listdata()
            {
                this.$router.push(
                {
                    path: '/listdeta'
                } )
            },
            login()
            { //登录
                this.$router.push(
                {
                    path: '/login'
                } )
            },
            regist()
            { //注册
                this.$router.push(
                {
                    path: '/regist'
                } )
            },
            dyindex()
            {
                this.$router.push(
                {
                    path: "/dyindex"
                } )
            }

        },
        computed:
        {

        }
    }
</script>

<style scoped="scoped">
    @import '../assets/style/base.css';
    .right-wid{width:800px}
    .right-wid-son{width:86%;border-right:1px solid #f5f5f5;}
    .right-title-p{font-size:14px;color:#666666;margin:auto 16px;cursor:pointer;}
    .right-jiantou{width:12px;height:7px;margin:auto 6px}
    .jifen{
        color: #ffb22d;
        position: relative;
    }

    .typeactive .jifen {
        color: #FFFFFF;
    }

    .typeactive .jifen span::before {
        background-image: url("../assets/image/img/2 (1).png");
    }

    .jifen span {
        position: relative;
    }

    .jifen span::before {
        content: "";
        position: absolute;
        background-image: url("../assets/image/img/2 (2).png");
        background-repeat: no-repeat;
        width: 20px;
        height: 18px;
        top: 2px;
        left: -35px;
    }

    .zhekou {
        color: #FF6B6B;
        position: relative;
    }

    .typeactive .zhekou {
        color: #FFFFFF;
    }

    .typeactive .zhekou span::before {
        background-image: url("../assets/image/img/折扣页/zhekouB.png");
    }

    .zhekou span {
        position: relative;
    }

    .zhekou span::before {
        content: "";
        position: absolute;
        background-image: url("../assets/image/img/折扣页/折扣.png");
        background-repeat: no-repeat;
        width: 20px;
        height: 18px;
        top: 2px;
        left: -35px;
    }

    .input-box {
        display: flex;
        align-items: center;
    }

    .showShop-right>div:nth-last-of-type(1) .product-line {
        display: none;
    }

    .product-line {
        width: 100%;
        border-top: 1px dashed #CFCFCF;
        margin: 0.625rem 0;
    }

    .listactive {
        color: #FFFFFF !important;
        background-color: #11D165;
        border-radius: 12px;
    }

    .product-subtype-child {
        display: flex;
        align-items: center;
        margin-top: 0.625rem;
    }

    .product-subtype-name p:hover {
        color: #ffffff;
        background-color: #11D165;
        border-radius: 12px;

    }

    .product-subtype-name p,
    .product-subtype-child p {
        font-size: 14px;
        height: 1.5rem;
        line-height: 1.5rem;
        color: #666666;
        font-weight: 400;
        /* margin-right: 1.25rem; */
        cursor: pointer;
        padding: 0 0.625rem;
    }

    .product-subtype-name {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
    }

    .product-subtype {
        width: 100%;
        margin-left: 0.625rem;
    }

    .product-name {
        width: auto;
        color: #333333;
        font-size: 16px;
        font-weight: 400;
        min-width: 5rem;
        text-align: right;
        margin-right: 0.625rem;
    }

    .product-name-box {
        display: flex;
        padding-left: 1rem;
    }

    .type2 {
        display: inline-block;
    }

    .product-discont-name {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #434343;
        /* margin-right: 12px; */
        text-align: justify;
        height: 14px;
        line-height: 34px;
    }

    .typeactive {
        color: #FFFFFF !important;
        background-color: #11D165 !important;
    }

    .showShop-left-item {
        width: 100%;
        height: 2.5rem;
        line-height: 2.5rem;
        cursor: pointer;
        padding-left: 100px;
    }

    .showShop-right {
        /* width: calc(75rem - 16.8125rem); */
        /* width: calc(928px - 16.8125rem); */
        width: calc(1200px - 16.8125rem);
        margin-top: 14px;
        /* width: 20rem; */
        height: auto;
        min-height: 8.4375rem;
        background-color: #FFFFFF;
        padding: 0.625rem 0;
        box-shadow: 0px 0px 20px 0px rgb(175 198 255 / 29%);
    }

    .showShop-left {
        width: 16.8125rem;
        height: auto;
        background-color: #F2F2F2;
        margin-top: 14px;
        box-shadow: 0px 0px 20px 0px rgb(175 198 255 / 29%);
    }

    .showAllshop-box {
        width: 75rem;
        height: auto;
        margin: auto;
        position: absolute;
        /* bottom: -17.5rem; */
        left: 50%;
        transform: translate(-50%);
        display: flex;
        justify-content: flex-start;
        z-index: 15;
    }

    .shopcart-btn>span {
        display: inline-block;
        /* width: 1.25rem;
        height: 1.25rem; */
        border-radius: 50%;
        text-align: center;
        /* line-height: 1.25rem; */
        color: #FFFFFF;
        font-size: 10px;
        background-color: #FF4949;
        padding: 0.1rem 0.25rem;
        box-sizing: border-box
    }

    .shopcart-btn>p {
        color: #11D165;
        font-size: 16px;
        font-weight: 400;
        margin: 0 6px
    }

    .shopcart-btn>img {
        width: 1.5rem;
        height: 1.1875rem;
    }

    .shopcart-btn {
        width: 8.125rem;
        height: 2.875rem;
        box-shadow: 0px 2px 7px 0px rgba(35, 24, 21, 0.19);
        display: flex;
        align-items: center;
        padding: 0 0.625rem 0 0.625rem;
        /* justify-content: space-between; */
        /* position: absolute; */
        /* top: 7rem; */
        /* right: 18rem; */
        /* cursor: pointer; */
        /* margin: auto 0; */
    }

    .navActive {
        color: #11D165 !important;
        /* color: #929292 !important *灰度 */
    }

    .search-hot {
        width: 33.875rem;
        margin: 0.5rem 0 0 0;
        color: #666666;
        font-size: 12px;
        font-weight: 400;
        /* margin-left: 3.875rem; */
        /* margin-top: 0.75rem; */
        /* text-align: center; */
    }

    .header-welcome {
        display: flex;
    }

    .header_box {
        width: 100%;
        height: 100%;
        background: #FFFFFF;
        position: relative;
    }



    .header_topsimg {
        background: url('../assets/image/iocn/iocnfont.png') no-repeat -22px -4px;
        width: 15px;
        height: 13px;
        position: absolute;
        margin: 0.3rem -0.4rem;
    }



    .header_logo {
        width: 100%;
        display: flex;
        justify-content: center;
        position: relative;
    }

    .header_logo>img {
        width: 15.25rem;
        height: 4.625rem;
    }

    .header_logos {
        width: 75rem;
        display: flex;
        justify-content: space-between;
        /* display: flex;
        justify-content: flex-start; */
        margin-top: 1.25rem;
    }

    .header_input {
        /* margin-left: 9.5rem; */
        /* display: flex;
        align-items: center; */
        margin: auto 0
    }

    /* .input-box input {
        width: 29.0625rem;
        height: 2.5rem;
        border: 2px solid #11D165;
        border-radius: 5px 0 0 5px;
        margin-top: 7px;
        outline: none;
        padding-left: 1rem;
    } */
    .input-box-inputbox {
        width: 29.0625rem;
        height: 2.5rem;
        border: 2px solid #11D165;
        border-radius: 5px 0 0 5px;
        outline: none;
        padding-left: 1rem;
    }

    .header_input>img {
        margin-right: 6px;
    }

    .header_input span {
        color: #404040;
        font-size: 18px;
        margin-right: 6px;
        font-weight: 400;
        cursor: pointer;
    }

    .header_inputs {
        width: 4.8125rem;
        height: 2.5rem;
        background: #11D165;
        border-radius: 0 3px 3px 0;
        /* position: absolute; */
        /* margin: -2.65rem 0; */
        cursor: pointer;
        color: #ffffff;
        font-size: 1rem;
        text-align: center;
        line-height: 2.5rem;
    }

    .header_inputsimgs {
        background: url('../assets/image/iocn/iocnfont.png') no-repeat -371px -43px;
        width: 23px;
        height: 23px;
        margin: 0.5rem 1.5rem;
    }

    .header_lisimgsA {
        background: url('../assets/image/iocn/iocnfont.png') no-repeat -107px -404px;
        width: 20px;
        height: 12px;
        position: absolute;
        margin: 1.1rem 3.5rem;
    }

    .header_title {
        width: 100%;
        display: flex;
        justify-content: center;
        /* border-bottom: 3px solid #11D165; */
        /* padding: 0 0 14px 0; */
        box-sizing: border-box;
    }

    .header_titles {
        width: 75rem;
    }

    .header_tilis {
        display: flex;
        margin-top: 1.25rem;
    }

    .header_lis {
        width: 16.8125rem;
        height: 3rem;
        background: #11D165;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 45px;
        text-align: center;
        margin-top: 0.6rem;
        cursor: pointer;
    }

    .header_titlet {
        display: flex;
        margin-left: 2.5rem;
    }

    .header_titletA {
        font-size: 17px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3F3E3E;
        width: 6.5rem;
        height: 2.5rem;
        text-align: center;
        margin-top: 1rem;
        cursor: pointer;
    }

    /* .header_titletA:hover{
		cursor: pointer;
		background-color: #11D165;
		color: #FFFFFF;
	} */
    .product-list-title {
        font-size: 16px;
        color: #11D165;
        font-weight: 400;
        padding: 0.4rem 0 0 1rem;
    }

    .product-line2 {
        width: 100%;
        border-top: 1px dashed #CFCFCF;
        margin: 1rem 0;
    }

    .zk-new-p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        height: 24px;
        line-height: 22px;
        color: #A0A0A0;
        margin-top: 12px
    }

    .product-discont-name a {
        color: #A0A0A0;
        padding: 0rem 0.5rem;
        border: 1px solid #A0A0A0;
        border-radius: 12px;
    }

    .product-discont-name a:hover {
        color: #ffffff;
        border: 1px solid #11D165;
        background-color: #11D165;
    }
    .product-discont-name2 a:hover {
        color: #ffffff;
        border: 1px solid #ffb22d;
        background-color: #ffb22d;
    }

    .product-discont-name3 a:hover {
        color: #ffffff;
        border: 1px solid #FF6B6B;
        background-color: #FF6B6B;
    }
</style>
<style>
    .header-welcome .el-button--primary {
        color: #333333;
        background-color: #F2F2F2;
        border-color: #F2F2F2;
    }

    .header-welcome .el-button--primary:focus,
    .header-welcome .el-button--primary:hover {
        background: #F2F2F2;
        border-color: #F2F2F2;
        color: #333333;
    }

    .header-welcome el-dropdown-item:hover {
        color: #333333;
    }
</style>